export const CUSTOM_TOOL_SHORTCUTS = {
  graph: "c",
  equation: "m",
} as const;

export type CustomToolShortcut = keyof typeof CUSTOM_TOOL_SHORTCUTS;

export const getCustomToolShortcutLabel = (tool: CustomToolShortcut) =>
  CUSTOM_TOOL_SHORTCUTS[tool].toUpperCase();

export const getCustomToolFromShortcut = (
  event: Pick<
    KeyboardEvent,
    | "altKey"
    | "ctrlKey"
    | "isComposing"
    | "key"
    | "metaKey"
    | "repeat"
    | "shiftKey"
  >,
): CustomToolShortcut | null => {
  if (
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    event.repeat ||
    event.isComposing
  ) {
    return null;
  }

  const key = event.key.toLowerCase();
  return (
    (Object.keys(CUSTOM_TOOL_SHORTCUTS) as CustomToolShortcut[]).find(
      (tool) => CUSTOM_TOOL_SHORTCUTS[tool] === key,
    ) ?? null
  );
};
